module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/img/intro-backup-desktop.b5d7f391.jpg";